import type { ReactNode } from 'react';

interface AppShellProps {
  title: string;
  /** Right-side header content (sign-out button, queue badge, etc) */
  headerRight?: ReactNode;
  children: ReactNode;
}

/** Shared layout: dark teal header (matches Doctor's Journal app), white body. */
export function AppShell({ title, headerRight, children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-slate-200">
      <header className="bg-teal-700 text-white shadow-md">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-lg font-semibold">Doctor's Journal</span>
            <span className="text-teal-200 text-sm hidden sm:inline">— {title}</span>
          </div>
          {headerRight && <div>{headerRight}</div>}
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
